import { render, staticRenderFns } from "./invitePage.vue?vue&type=template&id=112ef852&"
import script from "./invitePage.vue?vue&type=script&lang=js&"
export * from "./invitePage.vue?vue&type=script&lang=js&"
import style0 from "./invitePage.vue?vue&type=style&index=0&id=112ef852&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports